import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { EformAPI } from '../../e-form.api';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Group } from '../../model/eform-type';
import { MatSort } from '@angular/material/sort';
import { RestDataSource } from '../../../shared/rest-data-source';
import { Toast } from '../../../shared/toast/toast';
import {PaginatorComponent} from '../../../shared/paginator';
import { AppLoaderComponent } from 'app/shared/app-loader/app-loader.component';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})
export class GroupListComponent implements OnInit, AfterViewInit {
  dataSource = new RestDataSource<Group>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
  @ViewChild('container') container: ElementRef;
  @ViewChild(AppLoaderComponent, {static: true}) loader: AppLoaderComponent;
  displayedColumns = ['select', 'name', 'groupCode'];


  searchFocused: boolean;
  searchResult: any[];
  preventBlur: boolean;
  filterValue = '';
  private timer: any;
  params :any

  enterSearch :boolean
  tableAction : boolean

  constructor(private api: EformAPI, @Inject(MAT_DIALOG_DATA) private data: Group[],
              private dialogRef: MatDialogRef<GroupListComponent>, private toast: Toast) { }

  ngOnInit(): void {
    this.loader.show();
    this.exsitingIds();
    this.loadData('group_name');
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.changes.subscribe((params: any) => {
      this.params = params;
      if(this.enterSearch || this.tableAction){
        this.loadData()
      }
      this.loader.hide();
    });
 }

 exsitingIds() {
   const id = [];
   this.data.forEach(val => {
     if (val.id !== 'Everyone') { id.push(val.id); }
     if (id.length === 0) { id.push(0); }});
   return id;
 }

  save() {
    this.dialogRef.close(this.dataSource.selected);
  }

  onSearchFocus() {
    this.searchFocused = true;
 }

 onSelectItem(item: any){
  let groupArray: Group[] = [];
  var target = new Group()

  target.id = item.id;
  target.name = item.name
  target.groupCode = item.groupCode
  target.siteCode = item.siteCode

  groupArray.push(target)
  this.dialogRef.close(groupArray);
 }

 
 onSearchChange(input: any, e: any) {
  if (e.keyCode === 13) {
     return;
  }

  this.searchResult = null;
  this.searchChange(input);
}

 loadData(sort?:any){
  this.api.listGroups(localStorage.getItem('tin'), this.exsitingIds(), this.params,null,null,sort)
  .subscribe(data => {
     this.dataSource.loaded(data);
     this.container.nativeElement.scrollTop = 0;
     this.loader.hide();
     this.enterSearch = false
     this.tableAction = false
  }, e => {
     this.toast.error(e.message);
     this.loader.hide();
     this.enterSearch = false
     this.tableAction = false
  });
 }

 checkPageChange(){
  this.tableAction = true
 }

 onSearchBlur() {
    setTimeout(() => {
       if (!this.preventBlur) {
          this.searchFocused = false;
       }
    }, 300);
 }

 searchChange(input:any) {
  this.searchFocused = true;
  this.searchResult = null;
    if (this.timer) {
       clearTimeout(this.timer);
    }
    this.filterValue = encodeURIComponent(input.value.trim());
    if (this.filterValue.length === 0) {
       return;
    }

    this.timer = setTimeout(() => {
       this.timer = null;
       this.enterSearch = false
       this.dataSource.filter = this.filterValue;
       this.api.listGroups(localStorage.getItem('tin'), this.exsitingIds(), null,8,this.filterValue)
       .subscribe(data => {
        if (this.timer == null) {
          this.searchResult = data.content;
        }
          
       }, e => {
          this.toast.error(e.message);
       });
    }, 300);
 }
 
  onSearch(value: any) {
    this.searchFocused = false;
    this.loader.show();
      this.enterSearch = true
      if(this.dataSource.filter === value.trim()){
              this.loadData();
      }
      this.dataSource.filter = value.trim()
  }

}
